import React, {useEffect} from 'react';
import { Spinner } from 'react-bootstrap';

const MySpinner = () => {

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => (document.body.style.overflow = "unset");
    });

	return(
        <div className="load-spinner">
            <Spinner animation="border" variant="primary" />
        </div>
	);
};

export default MySpinner;
